export const chubbTravelEmail = "boi.travelinsurance@chubb.com";
